const NotFound = () => {
  return (
    <div className="container vh-100 d-flex align-items-center justify-content-center">
      <div className="text-center">
        <h1 className="display-1 fw-bold text-danger">404</h1>
        <h4 className="mb-3">Page Not Found</h4>
        <p className="text-muted mb-4">
          Sorry, the page you are looking for does not exist.
        </p>

        <a href="/" className="btn btn-primary px-4">
          Go Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
